import { render, staticRenderFns } from "./WriteFrameNumber.vue?vue&type=template&id=5147f49a&scoped=true&"
import script from "./WriteFrameNumber.vue?vue&type=script&lang=js&"
export * from "./WriteFrameNumber.vue?vue&type=script&lang=js&"
import style0 from "./WriteFrameNumber.vue?vue&type=style&index=0&id=5147f49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147f49a",
  null
  
)

export default component.exports